import React, {useEffect, useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Button from '@mui/material/Button';
import styles from './NavBar.module.scss';
import {useMediaQuery} from '@mui/material';

export const stABOUT_US = "aboutus";
export const stCONTACT = "contact";
export const stTERMS = "terms";
export const stPRIVACY = "privacy";
export const stHOME = "home";
export const stFEATURES = "features";


const NavBar: React.FC = () => {

    const isLargeScreen = useMediaQuery('(min-width:700px)');
    const [menuOpen, setMenuOpen] = useState(false);




    const options = {
        "About Us": stABOUT_US,
        "Contact": stCONTACT,
        "Terms & Conditions": stTERMS,
        "Privacy": stPRIVACY
    }

    const scrollTo = (id: string) => {
        const element = document.getElementById(id) as HTMLDivElement;
        element.scrollIntoView({
            behavior: "smooth",
        });
    };

    const handleMenuToggle = () => {
        setMenuOpen(!menuOpen);
    };

    // automatically scroll to the section in the location
    useEffect(() => {
        const url = window.location.href;
        if (url.includes("#")) {
            const location = url.split("#")[1];
            setTimeout(() => {
                scrollTo(location);
            }, 800);
        }
    }, []);

    return (
        <AppBar position="fixed" className={styles.appBar}>
            <Toolbar>
                <a href={"/"} className={styles.Alogo}>
                        <img src="/equiscrib.png" alt="EquiQuill Logo" style={{height: 60}}/>
                        <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                            EquiQuill
                        </Typography>
                </a>
                <div className={styles.spacer}></div>
                <Button color="inherit" href="https://app.equiquill.com/">Login</Button>
                {isLargeScreen ? (
                    <>
                        {Object.keys(options).map((option, index) => (
                                <Button color="inherit" onClick={() => scrollTo(options[option as keyof typeof options])}
                                        key={index}>{option}</Button>
                            )
                        )}
                    </>
                ) : (
                    <>
                        <IconButton edge="end" color="inherit" aria-label="menu" onClick={handleMenuToggle}>
                            <MenuIcon/>
                        </IconButton>
                        {menuOpen && (
                            <div className={styles.menuOptions}>
                                {Object.keys(options).map((option, index) => (
                                    <Button color="inherit" onClick={() => {
                                        scrollTo(options[option as keyof typeof options]);
                                        handleMenuToggle();
                                    }}
                                            key={index}>{option}</Button>
                                ))}
                            </div>
                        )}
                    </>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default NavBar;